export const EMAIL_VALIDATOR =
  /^(([a-zA-Z0-9+_.-~]+(-[a-zA-Z0-9+_.-~]+)*)|("[a-zA-Z0-9+_.-~]+"))@(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})$/;

// /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const urlRegex =
  /^((?:https?:\/\/)?(?:www\.)?[-\w@:%.+~#=]{1,256}\.[a-z]{2,6}\b[-\w@:%+.~#?&\/=]*|)$/;

export const numbersAndLettersRegex =
  /^([a-zA-Z0-9\u0600-\u06FF\u0660-\u0669\u06F0-\u06F9 _.-]+)$/;

export const spacesRegex = /^\S*$/;

export const strongPassRegex =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[~!@#$%^*()_\-{}[\]";:’<>?.+]).{10,24}$/;

export const mediumPassRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,24}$/;

export const PHONE_VALIDATOR = /^[0-9\s()+-]+$/;

export const OLD_PHONE_VALIDATOR =
  /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;

export const PATH_NAME_BASE = /\/l\/[a-z|]+\/?/;
